import { Type } from '../Type';
export class DataList extends Array {
    type = Type.List;
    logicalType;
    tags;
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.tags = tags;
        this.logicalType = logicalType;
    }
    static get [Symbol.species]() {
        return Array;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YUxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL2xpc3QvRGF0YUxpc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUc5QixNQUFNLE9BQU8sUUFBUyxTQUFRLEtBQWU7SUFDbEMsSUFBSSxHQUFTLElBQUksQ0FBQyxJQUFJLENBQUE7SUFDdEIsV0FBVyxDQUFjO0lBQ3pCLElBQUksQ0FBVztJQUV4QixZQUNFLFNBQXFCLEVBQUUsRUFDdkIsV0FBeUIsRUFDekIsSUFBZTtRQUVmLEtBQUssQ0FBQyxHQUFHLE1BQU0sQ0FBQyxDQUFBO1FBQ2hCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFBO0lBQ2hDLENBQUM7SUFFRCxNQUFNLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQ3pCLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztDQUNGIn0=